import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setSentryUser } from "../Sentry/utils";
import { useAuth } from "./context";
import { getUserData } from "./service";

const SingleSignOnUser = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const userData = await getUserData();

      if (!userData) {
        if (!cancelled) {
          navigate("/auth/error?reason=session_unavailable", { replace: true });
        }
        return;
      }

      if (cancelled) return;

      setUser(userData);
      setSentryUser(String(userData.user_id ?? ""), userData.groups ?? []);

      const redirectUrl = localStorage.getItem("redirectAfterLogin");
      if (redirectUrl) {
        localStorage.removeItem("redirectAfterLogin");
        navigate(redirectUrl, { replace: true });
        return;
      }

      navigate(userData.only_gate_group ? "/gate" : "/dashboard", {
        replace: true,
      });
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate, setUser]);

  return <h1>Connecting to Quantilia</h1>;
};

export default SingleSignOnUser;
